@use "/src/styles/functions";

.flag {
  width: functions.toRem(20);
  height: functions.toRem(20);
  border-radius: 50%;

  object-fit: cover;
  object-position: center;

  img {
    object-fit: cover;
    object-position: center;
  }
}
